export const {
    REACT_APP_API_HOST,
    REACT_APP_RESOURCES_HOST,
    REACT_APP_ENVIRONMENT
} = process.env;